import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Marquee from "../components/Marquee";
import { Reveal, Overline } from "../components/Reveal";
import { SERVICES } from "../data";

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-20">
      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-16 pb-12">
        <Reveal>
          <Overline>Our craft</Overline>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-slate-100 tracking-tight leading-[1.1] max-w-3xl">
            Lighting for <span className="text-gold-gradient">every</span> space, season & celebration
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed">
            From permanent architectural trim to one-night wedding magic, every GlowMode install is measured, custom cut, and finished with invisible wiring. Residential and commercial.
          </p>
        </Reveal>
      </section>

      <Marquee />

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-24 space-y-20">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id}>
            <div
              data-testid={`service-row-${s.id}`}
              className={`grid gap-8 lg:gap-14 items-center lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            >
              <div className="group relative overflow-hidden rounded-2xl border border-white/5 h-72 sm:h-96">
                <img
                  src={s.img}
                  alt={s.name}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] font-mono uppercase tracking-[0.2em] text-gold-light glass-panel border border-gold/30">
                  {s.tag}
                </span>
              </div>
              <div>
                <p className="text-xs font-mono text-gold tracking-[0.3em] mb-3">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-semibold text-slate-100 tracking-tight mb-4">{s.name}</h2>
                <p className="text-slate-400 leading-relaxed mb-8">{s.desc}</p>
                <Link
                  to={`/book?type=${encodeURIComponent(s.name)}`}
                  data-testid={`service-book-${s.id}`}
                  className="group inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
                >
                  Book this service
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-white/5 bg-charcoal/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 text-center">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl font-serif font-semibold text-slate-100 mb-6">Not sure which glow fits? We'll help you decide.</h2>
            <Link
              to="/book"
              data-testid="services-bottom-book-button"
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-obsidian bg-gradient-to-br from-gold-light via-gold to-gold-dark transition-all duration-300 hover:shadow-[0_0_35px_rgba(212,175,55,0.5)] hover:-translate-y-0.5"
            >
              Get a Free Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
